import { lighten } from '@mui/material';

import { BarChartProps } from '@occc-app/design-system';

import {
  MISSING_STORES_GREEN_BAR_COLOR,
  MISSING_STORES_RED_BAR_COLOR,
  MISSING_STORE_YELLOW_BAR_COLOR,
  MISSING_STORES_LOW_THRESHOLD,
  MISSING_STORES_MEDIUM_THRESHOLD,
} from '../scan-data-overview.constants';
import { calculateMissingStoresPercentage } from '../scan-data-overview.utils';
import { MissingStoresRawItem } from '../scan-data-missing-stores-chart/scan-data-missing-stores-chart.types';

const NON_SELECTED_COLOR_LIGHTEN_COEFFICIENT = 0.5;

export const getBarColor: BarChartProps<MissingStoresRawItem>['getBarColor'] = (
  { value, rawItem },
  _items,
  _totalValue,
  isRangeSelected,
  isBarInRange,
) => {
  const submittedStoresCount = rawItem?.submittedStoresCount ?? 0;
  const percentage = calculateMissingStoresPercentage(value, submittedStoresCount);
  let barColor: string = MISSING_STORES_GREEN_BAR_COLOR;

  if (percentage > MISSING_STORES_LOW_THRESHOLD && percentage <= MISSING_STORES_MEDIUM_THRESHOLD) {
    barColor = MISSING_STORE_YELLOW_BAR_COLOR;
  }

  if (percentage > MISSING_STORES_MEDIUM_THRESHOLD) {
    barColor = MISSING_STORES_RED_BAR_COLOR;
  }

  if (isRangeSelected && !isBarInRange) {
    barColor = lighten(barColor, NON_SELECTED_COLOR_LIGHTEN_COEFFICIENT);
  }
  return barColor;
};
